export default __webpack_public_path__ + "static/media/photo--sm--71.e646c568.jpg";